import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'ums/v1/supplier-intelligence/sheets/refresh';

type TData = { success: boolean; message: string };
type TError = AxiosError;
type TVariables = string; // sheet name: 'contacts' | 'products' | 'catalogs'
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useRefreshSiSheetApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async (sheetName: string) => {
    try {
      const { data } = await http.post(`${endpoint}/${sheetName}`);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [endpoint],
    onSuccess: (_data, sheetName) => {
      toast({ description: `${sheetName.charAt(0).toUpperCase() + sheetName.slice(1)} sheet refresh queued`, status: 'success' });
    },
  });
}
